var map = {
	"./triangle-0.gif": "8b86",
	"./triangle-10.gif": "b43a",
	"./triangle-100.gif": "8b44",
	"./triangle-15.gif": "4f9c",
	"./triangle-20.gif": "d648",
	"./triangle-25.gif": "b313",
	"./triangle-30.gif": "ad90",
	"./triangle-35.gif": "9233",
	"./triangle-40.gif": "56a1",
	"./triangle-45.gif": "2ec3",
	"./triangle-5.gif": "018f",
	"./triangle-50.gif": "8fe6",
	"./triangle-55.gif": "2658",
	"./triangle-60.gif": "f6eb",
	"./triangle-65.gif": "c650",
	"./triangle-70.gif": "1989",
	"./triangle-75.gif": "12fd",
	"./triangle-80.gif": "3f85",
	"./triangle-85.gif": "e2ed",
	"./triangle-90.gif": "c690",
	"./triangle-95.gif": "a1a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b11";